module.exports = __webpack_public_path__ + "img/tx.c393fcb7.png";